module.exports = __webpack_public_path__ + "img/11.2.TN.2421d223.png";